<template>
  <transition-group
    class="collapsible-question"
    name="questions"
    tag="div"
  >
    <h2
      v-if="questionInfo.title"
      :key="questionInfo.title"
      @click="toggleExpanded"
    >
      <img
        class="drop-down"
        :class="{ 'rotated' : isExpanded }"
        src="@/assets/art/arrow_drop_down.svg"
      />
      <span
        class="toggle-collapsible-text"
      >
        {{questionInfo.title}}
      </span>
    </h2>
    <div
      v-show="isExpanded || !questionInfo.title"
      :key="`${questionInfo.title}-div`"
      class="collapsible-container"
    >
      <recursive-help-answers
        :answers="questionInfo.answers"
        :isOrdered="questionInfo.isOrdered"
        :indent="indent + 8"
      />
    </div>
  </transition-group>
</template>

<script>
import RecursiveHelpAnswers from '@/components/RecursiveHelpAnswers'

export default {
  name: 'CollapsibleRecursiveQuestion',
  components: {
    RecursiveHelpAnswers
  },
  props: {
    questionInfo: {
      type: Object,
      default: undefined
    },
    indent: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      isExpanded: false
    }
  },
  methods: {
    toggleExpanded () {
      this.isExpanded = !this.isExpanded
    }
  }
}
</script>

<style scoped>
  .drop-down{
    cursor: pointer;
    display: inline-block;
    grid-column: 1 / 2;
    grid-row: 1 / 2;
    transform: rotate(180deg);
    transition: all 0.5s;
  }
  .rotated {
    transform: rotate(360deg);
  }
  .toggle-collapsible-text {
    cursor: pointer;
    grid-column: 2 / 3;
    grid-row: 1 / -1;
    margin-left: 5px;
  }
  .expanded {
    transform: rotate(180deg);
  }
  h2 {
    font-size: 22px;
    margin-top: 4px;
    margin-bottom: 4px;
    display: grid;
    grid-template-columns: auto 1fr;
    grid-template-rows: auto 1fr;
  }
  .questions-enter-active, .questions-leave-active {
    transition: all 0.5s ease;
  }
  .questions-enter, .questions-leave-to {
    transform: scaleY(0) translateY(-50%);
    transform-origin: top center;
  }
  a {
    text-decoration: underline;
  }
  .collapsible-container {
    padding-left: 15px;
  }
</style>
